/**
 * SubformulaCardBody — optional description, blocks editor, expression preview
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';
import type { FormulaBlockNode, FormulaSubformula } from '@trafficpulse/shared';

import { Input } from '@/components/ui/form/input';
import { cn } from '@/lib/utils';

import { BlocksBuilder } from '../../blocks';
import ExpressionPreview from '../../group/ExpressionPreview';

export interface SubformulaCardBodyProps {
  bodyId: string;
  collapsed: boolean;
  sub: FormulaSubformula;
  onChange: (patch: Partial<FormulaSubformula>) => void;
  onAstChange: (ast: FormulaBlockNode | null) => void;
}

const SubformulaCardBody: FC<SubformulaCardBodyProps> = ({
  bodyId,
  collapsed,
  sub,
  onChange,
  onAstChange,
}) => (
  <div id={bodyId} className={cn('space-y-2', collapsed && 'hidden')}>
    <Input
      value={sub.description ?? ''}
      onChange={(e) => onChange({ description: e.target.value })}
      placeholder="Short note (optional)"
      aria-label="Subformula description"
      className="h-8 text-xs font-normal"
    />
    <BlocksBuilder ast={sub.ast} onChange={onAstChange} />
    <ExpressionPreview expression={sub.expression} />
  </div>
);

export default SubformulaCardBody;
